<script setup lang="ts">
import { RouterView } from 'vue-router'
import NetworkStatusBanner from '@/components/display/NetworkStatusBanner.vue'
import ToastContainer from '@/components/display/ToastContainer.vue'
</script>

<template>
  <NetworkStatusBanner />
  <ToastContainer />
  <RouterView />
</template>
